import { uniqueId } from "library/database/split-id"
import { matchesSimilaritySearch } from "../lib/matches-similarity-search.mjs"

export function createSimilaritySelection({ allMatching = false } = {}) {
    return {
        allMatching,
        selectedTasks: {},
        excludedTasks: {},
    }
}

export function clearSimilaritySelection() {
    return createSimilaritySelection()
}

export function isSimilarityTaskSelected(selection, task) {
    if (!task?.id || task?.lock?.locked || task?.lock?.isLocked) return false
    if (selection.allMatching) return !selection.excludedTasks[task.id]
    return Boolean(selection.selectedTasks[task.id])
}

export function toggleSimilarityTask(selection, task) {
    if (!task?.id || task?.lock?.locked || task?.lock?.isLocked) return selection

    if (selection.allMatching) {
        const excludedTasks = { ...selection.excludedTasks }
        if (excludedTasks[task.id]) delete excludedTasks[task.id]
        else excludedTasks[task.id] = task
        return { ...selection, excludedTasks }
    }

    const selectedTasks = { ...selection.selectedTasks }
    if (selectedTasks[task.id]) delete selectedTasks[task.id]
    else selectedTasks[task.id] = task
    return { ...selection, selectedTasks }
}

export function getSelectedTaskCount(selection, availableCount = 0, search) {
    if (!selection.allMatching) return Object.keys(selection.selectedTasks).length
    const excludedCount = getExcludedTasksInSearch(selection, search).length
    return Math.max(0, availableCount - excludedCount)
}

export function getSelectedScheduleCount(selection, availableScheduleTaskCounts = [], search) {
    if (!selection.allMatching) {
        return new Set(
            Object.values(selection.selectedTasks)
                .map(({ scheduleId }) => uniqueId(scheduleId))
                .filter(Boolean)
        ).size
    }

    const excludedBySchedule = getExcludedTasksInSearch(selection, search).reduce((counts, task) => {
        const scheduleId = uniqueId(task?.scheduleId)
        if (scheduleId) counts[scheduleId] = (counts[scheduleId] ?? 0) + 1
        return counts
    }, {})

    return availableScheduleTaskCounts.filter(
        ({ scheduleId, taskCount }) => (excludedBySchedule[uniqueId(scheduleId)] ?? 0) < taskCount
    ).length
}

function getExcludedTasksInSearch(selection, search) {
    return Object.values(selection.excludedTasks).filter((task) => matchesSimilaritySearch(task, search))
}
